<template>
  <div>
    <v-combobox
      v-model="selected"
      :loading="loading"
      :items="itemsPlusDeep"
      :search-input.sync="searchInput"
      item-text="label"
      cached-items
      no-filter
      class="mx-4"
      flat
      hide-no-data
      hide-details="auto"
      hide-selected
      :label="label"
      solo
      outlined
      dense
      clearable
      return-object
    >
      <template slot="item" slot-scope="data">
        <div class="d-flex flex-row width100">
          <span class="font-weight-medium codeWidth mr-2">{{
            data.item.code ? data.item.code : ""
          }}</span>
          <div>
            <span v-html="simplifyLaterality(data.item.label)"></span>
          </div>

          <div class="ml-auto overline">ICD10</div>
        </div>
      </template>
    </v-combobox>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";

export default {
  name: "IcdAutocomplete",
  mixins: [FormatIcdMixin],
  props: {
    action: {
      // default action is to route to a code's page (or send query to search page)
      type: String,
      default: "route", // "emitCode" will emit the selected code to the parent
    },
    label: { type: String, default: "Search for ICD codes" },
  },
  data: function () {
    return { loading: false, items: [], searchInput: null, selected: null };
  },
  methods: {
    querySelections(term) {
      this.loading = true;

      // ApiServices.icdSearch(term)
      ApiServices.genericApiCall("/icd/search/" + term)
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    routeToPath(path) {
      // path = path.replace(/Search all ICD codes for '([^\0]*)'/gim, "$1");
      console.log(path);
      this.$router.push({ path: path }).catch(() => {});
    },
  },
  computed: {
    itemsPlusDeep: function () {
      let s = this.searchInput;
      if (!s || s == "") return [];
      let cloned = [...this.items];
      if (this.action !== "emitCode") {
        let deepSearch = {
          label: `Search all ICD codes for '${s}'`,
          search: s,
          code: "ALL",
        };
        cloned.push(deepSearch);
      }
      // console.log(cloned);
      return cloned;
    },
  },
  watch: {
    searchInput(val) {
      val && val !== this.selected && this.querySelections(val);
    },
    selected(obj) {
      // console.log("select");
      // console.log(obj);
      if (typeof obj === "string" || obj instanceof String) {
        obj = { search: obj };
      }
      if (this.action == "emitCode") {
        if (obj.code) this.$emit("code", obj.code);
        // if (obj.search)
        //   alert("Sorry, you can't launch a search from this page.");
      } else {
        if (obj.code) this.routeToPath(`/icd10/${obj.code}`);
        if (obj.search) this.routeToPath(`/icd10/search/${obj.search}`);
      }
    },
  },
};
</script>

<style scoped>
.codeWidth {
  min-width: 70px;
}
.width100 {
  width: 100%;
}
</style>
